import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CommonsService } from '../commons-service';
import { ParametersStartService } from '../parameters-start.service'
import { RepositoryService } from '../repository.service';
import { SaleModel } from '../models/sale-model';
import * as moment from 'moment';
declare const $: any;
declare const log: any;

@Component({
  selector: 'app-view-open-sales',
  templateUrl: './view-open-sales.component.html',
  styleUrls: ['./view-open-sales.component.css']
})
export class ViewOpenSalesComponent implements OnInit {

  environment = environment;

  showLinks = true
  typeSales = "Offer"
  textTitle = ""
  textFromTo = ""
  momentFrom: moment.Moment = moment().subtract(1, 'month');
  momentTo: moment.Moment = moment();

  sort = {
    column: "date",
    ascending: true
  }
  textSearch = ""
  currentPage = 0
  pageSize = environment.entriesPerPage;

  sales: SaleModel[] = [];

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected translate: TranslateService,
    private commons: CommonsService,
    protected repository: RepositoryService,
    private parametersStart: ParametersStartService) {
  }

  getTypeSales() {
    const routeParams = this.route.snapshot.paramMap;
    return String(routeParams.get('type'));
  }

  ngOnInit(): void {
    this.ngOnInitAsync();
  }

  async ngOnInitAsync() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.typeSales = this.getTypeSales()

    if (this.typeSales == "Offer") {
      this.translate.get("OPEN_SALES_TITLE_OFFERS").subscribe((translated: string) => {
        this.textTitle = translated
      })
    } else if (this.typeSales == "Order") {
      this.translate.get("OPEN_SALES_TITLE_ORDERS").subscribe((translated: string) => {
        this.textTitle = translated
      })
    } else if (this.typeSales == "Invoice") {
      this.translate.get("OPEN_SALES_TITLE_INVOICES").subscribe((translated: string) => {
        this.textTitle = translated
      })
    } else {
      throw Error("unknown type of sales " + this.typeSales)
    }

    let strDateLastSearch: string = await this.repository.readUtilityData("searchOpenSalesLastSearch");
    let momentLastSearch: moment.Moment = moment(strDateLastSearch);
    if (strDateLastSearch != "" && momentLastSearch.isValid() && momentLastSearch.isAfter(moment().subtract(10, 'hours'))) {
      let strDateFrom = await this.repository.readUtilityData("searchOpenSalesSearchFrom");
      let strDateTo = await this.repository.readUtilityData("searchOpenSalesSearchTo");
      this.momentFrom = moment(strDateFrom);
      this.momentTo = moment(strDateTo);
      this.textSearch = await this.repository.readUtilityData("searchOpenSalesText")
    }

    const minAllowed = moment(0); // Unix epoch start 

    this.textFromTo = this.momentFrom.format("DD.MM.YYYY") + " - " + this.momentTo.format("DD.MM.YYYY");

    const this_ = this;
    $('#div-date-range-3').daterangepicker({
      minDate: minAllowed,
      maxDate: moment().endOf('day'),
      startDate: this.momentFrom.clone(),
      endDate: this.momentTo.clone(),
      timePicker: false,
      opens: 'left',
      singleDatePicker: false,
      showDropdowns: false,
      linkedCalendars: true,            // false testen (zeigt normalerweise 2 Kalender nebeneinander)
      alwaysShowCalendars: true,         // erzwingt Anzeige der Kalender
      locale: {
        format: 'DD.MM.YYYY',
        "applyLabel": this.translate.instant("GENERAL_APPLY"),
        "cancelLabel": this.translate.instant("GENERAL_CANCEL"),
        // "firstDay": 1
      }
    }).on('apply.daterangepicker', function (ev: any, picker: any) {
      log("date range selected", picker.startDate.toDate(), picker.endDate.toDate());
      this_.momentFrom = picker.startDate;
      this_.momentTo = picker.endDate;
      this_.textFromTo = this_.momentFrom.format("DD.MM.YYYY") + " - " + this_.momentTo.format("DD.MM.YYYY");
      this_.search();
    });

    await this.repository.updateUtilityData("locationOriginSales", "viewOpenSales/" + this.typeSales)
    //this.textSearch = await this.repository.readUtilityData("searchOpenSalesText")
    this.sort.column = await this.repository.readUtilityData("sortOpenSalesColumn")
    this.sort.ascending = "true" == await this.repository.readUtilityData("sortOpenSalesAscending")
    this.currentPage = +(await this.repository.readUtilityData("showOpenSalesPage" + this.typeSales))

    await this.search();
  }

  async search() {
    await this.loadOpenSalesSearch();

    if (this.currentPage > this.numberOfPages() - 1)
      this.currentPage = this.numberOfPages() - 1;
    if (this.currentPage < 0)
      this.currentPage = 0;

    await this.repository.updateUtilityData("searchOpenSalesText", this.textSearch);
    await this.repository.updateUtilityData("searchOpenSalesLastSearch", (new Date()).toISOString());
    await this.repository.updateUtilityData("searchOpenSalesSearchFrom", this.momentFrom.toISOString());
    await this.repository.updateUtilityData("searchOpenSalesSearchTo", this.momentTo.toISOString());
  }

  private keyTimeout: any = null;

  keyUpEvent(event: any) {
    if (event.key.length != 1 && event.key != "Backspace") {
      event.preventDefault()
      return false;
    }

    if (this.keyTimeout) {
      clearTimeout(this.keyTimeout);
      this.keyTimeout = null;
    }

    this.keyTimeout = setTimeout(() => {
      this.search();
    }, 300)

    return true
  }

  numberOfPages() {
    if (this.sales && this.sales.length > 0)
      return Math.ceil(this.sales.length / this.pageSize);
    else
      return 1;
  }

  private async loadOpenSalesSearch() {
    var textSearchLC = "";
    if (this.textSearch && this.textSearch != "")
      textSearchLC = this.textSearch.toLowerCase();

    CommonsService.startTime("loadOpenSalesSearch")
    let openSales: SaleModel[] = []
    if (this.typeSales == "Offer") {
      if (environment.enableOpenOffers) {
        openSales = await this.repository.readOpenOffers(this.sort.column, this.sort.ascending)
      }
    }
    else if (this.typeSales == "Order") {
      if (environment.enableOpenOrders) {
        openSales = await this.repository.readOpenOrders(this.sort.column, this.sort.ascending)
      }
    }
    else if (this.typeSales == "Invoice") {
      if (environment.enableInvoices) {
        openSales = await this.repository.readInvoices("", this.sort.column, this.sort.ascending)
      }
    }

    this.momentFrom = this.momentFrom.clone().startOf('day');
    this.momentTo = this.momentTo.clone().endOf('day');
    let dateFrom: Date = this.momentFrom.toDate();
    let dateTo: Date = this.momentTo.toDate();

    openSales = openSales.filter((sale: any) => {
      if (sale.number && sale.number.toLowerCase().indexOf(textSearchLC) >= 0 ||
        sale.name.toLowerCase().indexOf(textSearchLC) >= 0 ||
        sale.street.toLowerCase().indexOf(textSearchLC) >= 0 ||
        sale.city.toLowerCase().indexOf(textSearchLC) >= 0 ||
        sale.zipCode.toLowerCase().indexOf(textSearchLC) >= 0) {
        if (sale.date.getTime() >= dateFrom.getTime() && sale.date.getTime() <= dateTo.getTime()) {
          return true
        } else {
          return false
        }
      } else
        return false
    })
    CommonsService.stopTime("loadOpenSalesSearch")

    this.sales = openSales

    return Promise.resolve()

  }

  timeLastSorting = new Date();
  changeSorting(column: string) {
    var timeNow = new Date();
    if (timeNow.getTime() - this.timeLastSorting.getTime() < CommonsService.TIME_TRIGGER_SORTING_MS)
      return;
    this.timeLastSorting = new Date();

    if (this.sort.column == column) {
      this.sort.ascending = !this.sort.ascending;
    } else {
      this.sort.column = column;
      this.sort.ascending = false;
    }

    const this_ = this;
    this.repository.updateUtilityData("sortOpenSalesColumn", this.sort.column)
      .then(() => {
        return this.repository.updateUtilityData("sortOpenSalesAscending", "" + this.sort.ascending);
      }).then(() => {
        setTimeout(function () {
          this_.loadOpenSalesSearch();
        }, 10);
      })
  }

  gotoCustomer(idCustomerAtClient: number) {
    log("goto customer " + idCustomerAtClient);
    if (idCustomerAtClient >= 0)
      this.router.navigateByUrl("/editCustomer/" + idCustomerAtClient)
  }

  storeCurrentPage() {
    this.repository.updateUtilityData("showOpenSalesPage" + this.typeSales, "" + this.currentPage);
  }

  clickedOnSale(sale: any) {
    this.router.navigateByUrl("/editSale/" + this.typeSales + "/" + sale.uuid + "/false");
  }
}
